import classNames from 'classnames';
import { useId } from 'react';
import type { FC } from 'react';
import { FormField, SkillsSlider } from '@reverse-hr/design-system';
import { SkillsSliderFieldHint } from '@components/Molecules/SkillsSliderField/_partials/SkillsSliderFieldHint';
import type { TSkillsSliderFieldProps } from '@components/Molecules/SkillsSliderField/SkillsSliderField.types';

export const SkillsSliderField: FC<TSkillsSliderFieldProps> = ({
  className,
  hint,
  label,
  value,
  variant = 'primary',
}) => {
  const sliderId = useId();

  const isHintVisible = !!hint?.message;

  const wrapperClassNames = classNames('app-c-skills-slider-field', className);

  const hintContent = isHintVisible ? (
    <SkillsSliderFieldHint {...hint} />
  ) : undefined;

  return (
    <FormField
      className={wrapperClassNames}
      hint={hintContent}
      id={sliderId}
      label={label}
    >
      <SkillsSlider
        id={sliderId}
        isPercentageHidden
        isReadOnly
        value={value}
        variant={variant}
      />
    </FormField>
  );
};
